import React from 'react';
import SessionList from './SessionList';

const Sidebar = ({ 
  sessions,
  currentSessionId,
  showSessionsList,
  onNewChat,
  onShowSettings,
  onSessionClick,
  onSessionDelete,
  onSessionRename,
  currentSessionName,
  onToggleList
}) => {
  return (
    <div className={`sidebar ${showSessionsList ? 'show-sessions' : ''}`}>
      <button className="new-chat-btn" onClick={onNewChat}>
        新建对话
      </button>
      <button className="settings-btn" onClick={onShowSettings}>
        设置
      </button>
      
      <div className="current-session" onClick={onToggleList}>
        <span className="current-session-name">{currentSessionName}</span>
        <span className="toggle-icon">{showSessionsList ? '▼' : '▲'}</span>
      </div>
      
      <SessionList 
        sessions={sessions}
        currentSessionId={currentSessionId}
        onSessionClick={onSessionClick}
        onSessionDelete={onSessionDelete}
        onSessionRename={onSessionRename}
      />
    </div>
  );
};

export default Sidebar; 